/**
 * 
 * @param {Array} valueList 键值对的属性值 {bsm:'1111'}
 * @param {Array} attrList 属性的中英文对照 {key:'bsm',value:'111',alias:'标识码'}
 * @param {String} type 用于区分数据展示的类型 如：'mvt'
 * @returns 
 */
// 将键值对形式的属性转换成为统一的数组形式（便于a-descriptions结果展示，支持中英文对照）
function transAttr(valueList,attrList,type){
  let attributeArr = []
  let array = []
  array = Object.keys(valueList).map(val=>({
    key:val,
    value:valueList[val],
    show:true
  }))
  if(attrList){
    array.forEach(arr=>{
      attrList.forEach(attr=>{
        if(arr.key == attr.name.toLowerCase()){
          let obj = {
            key: arr.key,
            value: arr.value,
            show: arr.show,
            alias: attr.alias,
            orderNo: attr.orderNo,
            type: type,
          }
          attributeArr.push(obj)
        }
      })
    })
  }else{
    attributeArr = array
  }
  return attributeArr
}

export {
  transAttr
}